
(function(template){
    define('vue!app/views/vue/e-reg-vue-app/components/shareWith/guestList',['Vue', 'vuex', 'underscore'],function(Vue, vuex, _){
        return {
            name:'guestList',

            template:template,

            computed: _.extend(vuex.mapState('pmsCheckin', ['shareWith'])),

            methods: {
                handleCheckBoxClick: function(e, groupMember) {
                    groupMember.AllowPosting = e.target.checked ? 'Y' : 'N';
                    this.$store.commit('pmsCheckin/updateShareWith', groupMember);
                },

                removeGuest: function(CustomerId) {
                     this.$store.commit('pmsCheckin/removeShareWith',{CustomerId: CustomerId});

                }
            }
        }
    })
})('<div class="row-fluid"> <div class="span6"> <table class="table" aria-label="Guest details"> <thead class="blueText"> <tr> <th>{{localization.roomReservation.pmsCheckIn.guestNameLabel}}</th> <th>{{localization.roomReservation.pmsCheckIn.shareExpenseLabel}}</th> </tr> </thead> <tbody> <tr v-for="groupMember in shareWith" :key="groupMember.CustomerId"> <td>{{groupMember.name}}</td> <td><input type="checkbox" :disabled="groupMember.fromFolio" :checked="groupMember.AllowPosting == \'Y\'" @change="handleCheckBoxClick($event, groupMember)" /></td> <td><i class="fas fa-trash-alt" @click="removeGuest(groupMember.CustomerId)"></i></td> </tr> </tbody> </table> </div> </div>');
